import React from 'react';
import translate from '../locales/linkSection';
import gif from '../assets/images/gif/patrick-masbourian.gif';
import Img from '../components/image';


function linkSection() {
    return (
        <div className="linkSection angle">
            <div className="large container medium-padding-vertical white">
                <div className="buttons">
                    <ul>
                        <li><a href={translate.planLink} target="_blank" rel="noreferrer" className="button">{translate.plan}</a></li>
                        <li><a href={translate.summaryLink} target="_blank" rel="noreferrer" className="button">{translate.summary}</a></li>
                        <li><a href={translate.reportLink} target="_blank" rel="noreferrer" className="button">{translate.report}</a></li>
                    </ul>
                </div>
                <Img lazySrc="https://site-cbc.radio-canada.ca/site/edi/gem-load-grise.gif" src={gif} alt={translate.alt} legend={translate.legend}/>
            </div>
        </div>
    )
}

export default linkSection;